import { Form, Popover } from "antd";
import { FC, HTMLAttributes } from "react";
import cn from "classnames";
import { DownIcon, ClassIcon } from "src/assets/Icons";
import { PASSENGER_CLASSES, INITIAL_CLASS } from "../../../../constants";
import ClassSelectContent from "../../ClassSelectContent/ClassSelectContent";

const ClassSelectionWeb: FC<{ wrapperProps?: HTMLAttributes<HTMLDivElement> }> = ({ wrapperProps }) => {
  const value = Form.useWatch("flightCabinClass") ?? INITIAL_CLASS.key;
  const selectedClassLabel = PASSENGER_CLASSES.find((c) => c.key === value)?.label;

  return (
    <Popover arrow={false} trigger={["click"]} forceRender content={<ClassSelectContent />}>
      <div
        className={cn(
          "text-font-minimal flex hover:text-background-primary w-full items-center gap-4 font-semibold md:justify-center",
          wrapperProps?.className,
        )}
      >
        <div className="flex items-center justify-center gap-2">
          <ClassIcon className="md:h-5 md:w-5" />
          {selectedClassLabel}
        </div>

        <span className="h-5 w-5 items-center justify-center flex">
          <DownIcon />
        </span>
      </div>
    </Popover>
  );
};

export default ClassSelectionWeb;
